import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { MessagingCard } from 'components/common/messaging-card/messaging-card';

export const InfositeMessagingCard = ({ model, errorBoundaryLabel, testId }) => {
  if (!model) {
    return null;
  }

  return (
    <ErrorBoundary label={errorBoundaryLabel}>
      <MessagingCard
        className="all-b-padding-three all-x-padding-six xl-x-padding-zero m-x-padding-zero s-x-padding-two"
        model={model}
        tag="section"
        testId={testId}
      />
    </ErrorBoundary>
  );
};
